/**
 * Generic matcher for data-blob key-value lookups
 * @module
 */

var _ = require('optimizely-client-fn');
var getFieldValue = require('../../utils/key_path').getFieldValue;
var match = require('../../lib/match');

/**
 *
 * @param {*} value
 * @param {Condition} cond
 * @return {boolean}
 */
module.exports = function(value:any, cond:Condition): boolean {
  // TODO(tyler): refactor this
  var data = getFieldValue(value, cond.name.split('.'));
  // TODO(tyler): this is pretty messy; restructure as object?
  if (_.isArray(data)) {
    return _.some(data, _.partial(match.hasMatch, cond.value, cond.match));
  }
  return match.hasMatch(cond.value, cond.match, data);
};

